import LanguageSwitch from "@/components/LanguageSwitch";
import { ENGINE_LANGS } from "@/i18n/languages";
import { ENGINE_NS, SHELL_NS } from "@/i18n/lazyCatalogs";

// ENGINE_NS: textos de las pantallas del Engine.
// SHELL_NS: menu compartido con el B2C (layout, cuenta, notificaciones) que usa el idioma activo
// tambien en rutas del Engine (engineLabelLang), por lo que tiene que estar listo antes de cambiar.
const NS = [...ENGINE_NS, ...SHELL_NS];

export default function LanguageSelect({ testid = "engine-language-select" }) {
    return <LanguageSwitch persist="account" namespaces={NS} langs={ENGINE_LANGS} testid={testid} />;
}
